<template>
  <div class="mx-sm-1 mt-9">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h3 class="card-title fw-bold mb-0">Rapport Global de Stock</h3>
        <div>
          <button class="btn btn-outline-primary" @click="exportToPDF">
            <i class="fe fe-printer me-2"></i> Exporter PDF
          </button>
        </div>
      </div>

      <div class="card-body">
        <TableWithFilters
            :columns="columns"
            :items="stockReport"
            :filterableFields="[]"
            :row-actions="rowActions"
            @tracking="viewTracking"
        >
          <template #cell-averagePrice="{ item }">
            {{ item.averagePrice.toFixed(2) }} FCFA
          </template>

          <template #cell-totalValue="{ item }">
            <strong class="text-success">{{ item.totalValue.toFixed(2) }} FCFA</strong>
          </template>

          <template #cell-managementType="{ item }">
  <span class="badge"
        :class="{
          'bg-info': item.managementType === 'CUMP',
          'bg-warning': item.managementType === 'FIFO',
          'bg-secondary': item.managementType === 'LIFO'
        }">
    {{ item.managementType }}
  </span>
          </template>

          <template #footer>
            <tr class="fw-bold text-end bg-light">
              <td colspan="3">Total Général</td>
              <td>{{ totals.currentStock.toFixed(2) }}</td>
              <td></td>
              <td>{{ totals.totalValue.toFixed(2) }} FCFA</td>
              <td></td>
            </tr>
          </template>
        </TableWithFilters>
      </div>

      <ModalGlobalStockReport
          v-if="selectedProduct"
          :product="selectedProduct"
          :movements="trackingData"
          ref="modalTracking"
      />

    </div>
  </div>
</template>

<script>
  import jsPDF from "jspdf";
  import autoTable from "jspdf-autotable";
  import TableWithFilters from "@/components/TableWithFilters.vue";
  import {
    sotckGlobalColumns,
    stockGlobalFilterableFields, stockGlobalRowActions
  } from "../../../helpers/constants";
  import ModalGlobalStockReport from "../../../components/modals/ModalGlobalStockReport.vue";
  import {exportPDF} from "../../../helpers/exporter";

  export default {
    name: 'GlobalStockReport',
    components: {ModalGlobalStockReport, TableWithFilters },
    data() {
      return {
        stockReport: [],
        totals: {
          currentStock: 0,
          totalValue: 0
        },
        columns: sotckGlobalColumns,
        filterableFields: stockGlobalFilterableFields,
        rowActions: stockGlobalRowActions,
        selectedProduct: null,
        trackingData: []
      };
    },
    methods: {
      viewTracking(product) {
        this.selectedProduct = product;
        this.loadTracking(product.productCode);
      },
      loadTracking(code) {
        this.trackingData = [];
        this.$http
            .get(`/stocks/${code}/tracking`)
            .then(({ data }) => {
              this.trackingData = data;
              $('#modal-trackingModalVisible').modal('show');
            })
            .catch((err) => {
              console.error("Erreur chargement tracking :", err);
            });
      },
      loadData() {
        this.$loading(true);
        this.$http
            .get('/stocks/global')
            .then(({ data }) => {
              this.stockReport = data;
              // Calcul des totaux
              this.totals.currentStock = data.reduce((sum, item) => sum + Number(item.currentStock || 0), 0);
              this.totals.totalValue = data.reduce((sum, item) => sum + Number(item.totalValue || 0), 0);
            })
            .catch(err => {
              console.error('Erreur lors du chargement du rapport stock global :', err);
            })
            .finally(() => {
              this.$loading(false);
            });
      },

      async exportToPDF() {
        const today = new Date().toLocaleDateString('fr-FR');

        await exportPDF({
          title: '📦 Rapport Global de Stock',
          filename: `rapport-stock-${today.replaceAll('/', '-')}.pdf`,
          table: {
            head: [['Code', 'Produit', 'Catégorie', 'Unité', 'Quantité', 'PU Moyen', 'Valeur']],
            body: this.stockReport.map(p => [
              p.productCode,
              p.productName,
              p.category,
              p.unit,
              p.currentStock?.toFixed(2) ?? '0.00',
              p.averagePrice?.toFixed(2) ?? '0.00',
              p.totalValue?.toFixed(2) ?? '0.00'
            ]),
            foot: [[
              '', '', '', 'Totaux',
              this.totals.currentStock?.toFixed(2) ?? '0.00',
              '',
              this.totals.totalValue?.toFixed(2) ?? '0.00'
            ]]
          }
        });
      }



    },
    mounted() {
      this.loadData();
    }
  };
</script>
